<script setup>
const { data: tags } = useFetch('/api/tag')

const query = ref('')

const filteredTags = computed( () => {
  if (!tags.value) return []
  if (!query.value) { return tags.value }
  return tags.value.filter(t => t.name.toLowerCase().includes(query.value.toLowerCase()))
})

</script>

<template>
  <section>
    <h2 class="mb-6">{{$t('Tags')}}</h2>
    <v-text-field v-model='query' :label="$t('Search')" prepend-inner-icon="mdi-magnify"></v-text-field>
    <section class='container max-w-80'>
      <v-chip :to='`/tag/${tag.id}`' color='primary' label class='ma-1' v-for='tag in filteredTags' :key='tag.id'>{{tag.name}}</v-chip>
    </section>
  </section>
</template>
